module.exports = __webpack_public_path__ + "img/crypto2.45c39878.png";